import React from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DELIVERY_CASH } from 'apps/auth/constants/Constants';

const PreCheckTerms = ({ preCheck: { deliveryMethod }, precheckTerms }) => {
    return <>{deliveryMethod !== DELIVERY_CASH && <DangerouslyHtml type="text" size="secondary" dangerouslyHtml={precheckTerms} />}</>;
};
export default PreCheckTerms;
